module.exports = "/assets/5acc48ddb18f39c47f63385880d95a49.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/YN.png
// module id = 2036
// module chunks = 0